import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dsnudsdke8: FaireBrandEntity = {
  token: "b_dsnudsdke8",
  type: "brand",
  name: "Essential Candy",
  avatarUrl:
    "https://cdn.faire.com/fastly/8e2ac801422e7cda2fdebe5a856550ac8faab3f2bab81aadc085091216d30ab5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/448576e94d668ad9aa370faf1a58d6e019b49b44ae0afefdb1d83334947094c6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8e2ac801422e7cda2fdebe5a856550ac8faab3f2bab81aadc085091216d30ab5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/448576e94d668ad9aa370faf1a58d6e019b49b44ae0afefdb1d83334947094c6.jpeg",
  location: "Easley, SC, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Essential Candy® was born from a simple act of care.\n\nOur founder, Tracy Ernst, began crafting plant-infused lozenges while supporting a close friend through a difficult health journey. She was searching for something comforting, made with real ingredients—something she could feel good about sharing. When she couldn’t find it, she created it.\n\nToday, Essential Candy creates plant-powered botanical lozenges made with organic ingredients, botanical extracts, and essential oils—never powders, fillers, or artificial additives.\n\nEach lozenge is individually wrapped, easy to enjoy on-the-go, and designed as a clean, enjoyable alternative to traditional supplements and candy. No pills. No gummies. Just lozenges.\n\nCrafted with real plant ingredients and thoughtfully developed for everyday use, our lozenges are perfect for travel, daily routines, and those looking for a more natural way to support their wellness.\n\nThrough our Candy With A Purpose™ mission, we donate products to individuals facing difficult times and those who support them—helping deliver small moments of comfort when they’re needed most.\n\nProudly USDA Organic, Gluten-Free Certified, Vegan Certified, Non-GMO (Organic Standard), Woman-Owned Certified, and Made in the USA.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:31.655Z",
    importedBy: "entity-db-cli",
  },
};
